// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "arkindex-" + (chunkId === 681 ? "users" : chunkId) + "-1.6.3.css";
};